module.exports = __webpack_public_path__ + "img/product_27.f32d944.webp";